import React from 'react';
import UITextInput from '../UITextInput';
import "./styles.css";

/**
 * @function UIShowHideInput
 * @return {React.Component}
 * @exported true
 * @description A text input that shows and Hides the input value
 * @example - The following example can be found in component "VerificationSecurityCodeView":
 * 
 * <UIShowHideInput revealPassword={ data.revealPassword } placeholder="Enter Security Code" value={ data.cardOnFileMerchant.verificationMerchantSecurityCode }
  onChange={ updateTextInput("verificationMerchantSecurityCode") } onShowHideClick={ onShowHideClick } />
 */

export default function UIShowHideInput(props) {
  const placeholder = props.placeholder ?? "";
  const revealPassword = props.revealPassword ?? false;

  const onShowHideClick = evt => {
    if(props.onShowHideClick) {
      props.onShowHideClick(revealPassword, evt);
    }
  }

  return(
    <div className="ui-show-hide-input">
      <UITextInput placeholder={ placeholder } type={ revealPassword ? "text" : "password" } value={ props.value } onChange={ props.onChange } />
      <div className="show-hide-text-container clickable" onClick={ onShowHideClick }>
        { !revealPassword &&
        <a className="show-text">SHOW</a>
        }
        { revealPassword &&
        <a className="hide-text">HIDE</a>
        }
      </div>
    </div>
  );
}